import angular from 'angular';
import uiRouter from 'angular-ui-router';
import errorNotificationComponent from './error-widget.component';

let errorNotificationModule = angular.module('error-notification', [uiRouter])

.component('errorNotification', errorNotificationComponent)

.name;

export default errorNotificationModule;



// WEBPACK FOOTER //
// ./client/app/common/error-widget/error-widget.js